import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { prefetchRouteData } from "@/app/prefetch";
import { useSession } from "@/session/SessionProvider";

export function useRoutePrefetch() {
  const queryClient = useQueryClient();
  const { session } = useSession();

  return useCallback(
    (path: string) => {
      void prefetchRouteData(queryClient, path, session);
    },
    [queryClient, session],
  );
}
